export const fullExperience = `
id
title
imageUrl
description
order
updatedAt
location {
  id
}
tiers {
  id
  price
  length
}
discounts {
  id
  type
  amount
}
coupons {
  id
  code
  type
  amount
}
`;
